/**
 * REST client for the research pipeline jobs API (§13).
 *
 * Jobs are lifecycle records for Step Functions executions of the
 * GTM research pipeline. The jobs Lambda (backend/functions/jobs)
 * owns concurrency, cancellation, and agent-progress tracking.
 */

import { request } from "./api.js";

export const listJobs = (projectId) =>
  request(`/api/projects/${projectId}/jobs`);

export const getJob = (projectId, jobId) =>
  request(`/api/projects/${projectId}/jobs/${jobId}`);

export const createJob = (
  projectId,
  { mode, priorJobId, agentId } = {},
) =>
  request(`/api/projects/${projectId}/jobs`, {
    method: "POST",
    body: JSON.stringify({
      mode: mode || "full",
      ...(priorJobId && { priorJobId }),
      ...(typeof agentId === "number" && { agentId }),
    }),
  });

// cancelJob and deleteJob hit the same DELETE endpoint — the backend
// decides based on job state (running/pending → cancel, terminal → hard
// delete). They're kept as separate names here so the UI callsites
// document intent.
export const cancelJob = (projectId, jobId) =>
  request(`/api/projects/${projectId}/jobs/${jobId}`, { method: "DELETE" });

export const deleteJob = (projectId, jobId) =>
  request(`/api/projects/${projectId}/jobs/${jobId}`, { method: "DELETE" });
